import React from "react";
import { useSelector } from "react-redux";
import { Skeleton } from "antd";
import useApplicationTracker from "customHooks/useApplicationTracker";

const NovaChatOptions = ({ product, isAiLoading, setMessageText }) => {
  const { captureUserEvent } = useApplicationTracker();
  const { accountId } = useSelector((state) => state.user);
  const employeeName = useSelector((state) => state.user.employeeFirstName);
  const novaGoalDefaultPrompts = useSelector(
    (state) => state?.aiFeatures?.goalsCreateWithNovaAI.defaultPrompts
  );

  const handleSelectDefaultPrompt = (prompt) => {
    setMessageText(prompt);
    captureUserEvent("nova_default_prompts_clicked", {
      accountId: accountId,
      prompt: prompt,
    });
  };
  return (
    <div className="ml-30 w-90 nova-chat-initial-promt">
      <p className="pl-8 mr-15 display-inlineblock">
        Hi {employeeName}, I&apos;m Nova your personal AI-powered assistant!
        I&apos;m here to help you create {product}. Select one of the option
        below to get started.
      </p>
      <div className="flex flex-col px-8 py-8 ml-8 nova-chat-options-wrapper">
        <div className="nova-chat-options-title">
          Here are some suggested prompts to get started
        </div>
        {isAiLoading ? (
          <Skeleton active className="w-80" />
        ) : (
          novaGoalDefaultPrompts.map((prompt, index) => (
            <div
              key={index}
              className="cursor-pointer nova-chat-option"
              onClick={() => handleSelectDefaultPrompt(prompt)}
            >
              {prompt}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NovaChatOptions;
